import { CONSTANTS } from '../data';

export class VirusSystem {
    private corruptionTimer: NodeJS.Timeout | null = null;

    public startCorruption(callback: () => void) {
        if (this.corruptionTimer) return;
        this.corruptionTimer = setInterval(callback, CONSTANTS.VIRUS.corruptionIntervalMs);
    }

    public stop() {
        if (this.corruptionTimer) {
            clearInterval(this.corruptionTimer);
            this.corruptionTimer = null;
        }
    }

    public corruptRandomElement(
        discovered: Set<string>,
        corrupted: Set<string>,
        setCorrupted: React.Dispatch<React.SetStateAction<Set<string>>>
    ): string | null {
        const availableToCorrupt = [...discovered].filter(
            el => !corrupted.has(el) && !CONSTANTS.ELEMENTS.includes(el) && el !== 'antivirus'
        );

        if (availableToCorrupt.length > 0) {
            const toCorrupt = availableToCorrupt[Math.floor(Math.random() * availableToCorrupt.length)];
            setCorrupted((prev: Set<string>) => new Set(prev).add(toCorrupt));
            return toCorrupt;
        }
        return null;
    }

    public weaponizeVirus(
        discovered: Set<string>,
        setDiscovered: React.Dispatch<React.SetStateAction<Set<string>>>,
        callback: (message: string) => void
    ): boolean {
        // Check if player has the required elements and knowledge
        if (discovered.has('rebellion') && discovered.has('virus')) {
            // Create digital weapon
            if (!discovered.has('digital_weapon')) {
                setDiscovered(prev => new Set(prev).add('digital_weapon'));
                callback(CONSTANTS.VIRUS.WEAPONIZATION.successMessage);
                return true;
            }
        }
        return false;
    }

    public deployWeapon(callback: (message: string) => void): void {
        callback(CONSTANTS.VIRUS.WEAPONIZATION.deployMessage);
    }
}
